// src/shared/utils/extplatBrandConfig.ts

import { FACEBOOK_APP_IDS, YOUTUBE_CLIENT_IDS } from '@/lib/constants/extplat';
import type { CustomercfgResellerData } from '@/lib/types/Customer';

/**
 * Brand-aware configuration for external platform integrations.
 *
 * Uses account-based detection (matching legacy behavior): a customer is a "reseller"
 * (themediacdn brand) if any reseller config fields are populated. This is critical
 * because the Facebook/YouTube app IDs determine which app secret the backend uses
 * when calling external APIs — using the wrong app ID causes auth failures.
 */
export class ExtPlatConfig {
  /** Check if a customer account is a reseller (themediacdn brand). */
  static isReseller(reseller: CustomercfgResellerData | undefined | null): boolean {
    if (!reseller) return false;
    return !!(
      reseller.supportUri ||
      reseller.supportPhone ||
      reseller.logoFileId ||
      reseller.logoFormat
    );
  }

  static getFacebookAppId(reseller: CustomercfgResellerData | undefined | null): string {
    return this.isReseller(reseller) ? FACEBOOK_APP_IDS.themediacdn : FACEBOOK_APP_IDS.streamhoster;
  }

  static getYouTubeClientId(reseller: CustomercfgResellerData | undefined | null): string {
    return this.isReseller(reseller) ? YOUTUBE_CLIENT_IDS.themediacdn : YOUTUBE_CLIENT_IDS.streamhoster;
  }
}
